<!--
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2023-02-13 15:09:30
-->
<template>
    <div class="list">
        <Header :headerData="headerData"></Header>
       
        <div class="query_box" >
            <a-input 
                class="query_field"     
                v-model:value="searchForm.frame_number" 
                allowClear
                style="width: 200px; margin: 0 10px 5px 0"
                :placeholder="t('rideDataStatistic.frame_number')"
                @change="handleInputChange('frame_number')"
            />
            <a-range-picker 
                v-model:value="searchForm.date" 
                allowClear
                @change="handleDateChange('date')"
            />

            <a-button type="primary" size="small" style="margin:0 10px" @click="handleSearch">
                <img src="@/assets/image/search.png" alt="" width="15" style="margin-right: 5px;margin-top:-3px">
                {{ $t('base.search') }}
            </a-button>
            <a-dropdown-button type="primary" size="small" :loading="loading1" @click="handleDownLoad('ride')">
                <component :is="$antIcons['DownloadOutlined']"></component>
                {{$t('rideDataStatistic.downloadRidePoints')}}

                <template #overlay>
                    <a-menu>
                        <a-menu-item key="1" @click="handleDownLoad('defaut')">
                            <component :is="$antIcons['DownloadOutlined']"></component>
                            {{$t('rideDataStatistic.downLoadFaultData')}}
                        </a-menu-item>
                    </a-menu>
                </template>
            </a-dropdown-button>
        </div>

        <!-- 表格 -->
        <a-spin :spinning="spinning" :tip="$t('rideDataStatistic.downLoadMsg')">
            <Table
                :table="table"
                @handleChangePagination="handleChangePagination"
            ></Table>
        </a-spin>

        <a-modal 
            v-model:visible="visible" 
            :title="t('rideDataStatistic.downloadRidePoints')" 
            :cancelText="$t('base.cancel')"
            :okText="okText"
            :width="500"
            :confirm-loading="confirmLoading"
            style="text-align:center"
            @ok="handleOK"
        >
            <a-select v-model:value="category" :placeholder="t('base.select')" style="width: 320px; text-align:left">
                <a-select-option value="">{{ $t('base.all') }}</a-select-option>
                <a-select-option :value="0">{{ $t('rideDataStatistic.simplifyData') }}</a-select-option>
                <a-select-option :value="1">{{ $t('rideDataStatistic.realtimeData') }}</a-select-option>
            </a-select>
        </a-modal>
    </div>
</template>

<script setup>
    import { onMounted, ref, reactive, createVNode, watch} from "vue";
    import Table from "@/components/Table.vue";
    import Header from "@/layouts/component/Header.vue";
    import { useRouter } from "vue-router";
    import { useI18n } from 'vue-i18n';
    import { message, Modal } from 'ant-design-vue';
    import { RideDataStatistic } from '@/api/RideDataStatistic.js';
    import { useDateTimestamp } from '@/hooks/useDateTimestamp';
    import { debounce } from 'lodash-es';
    import { getWeek } from '@/hooks/useGetWeek';

    const { t } = useI18n()

    const headerData = ref({
        menu:'menu.RideDataStatistic',
        menu_desc: 'menu.subRideDataStatistic',
        week: getWeek().week,
        current_time: getWeek().currentDate,
    })
    
    let spinning = ref(false)
    let dateTimestampeObj = reactive(null)
    const userInfo = ref(JSON.parse(sessionStorage.getItem('userInfo')))
    const searchForm = reactive({
        frame_number: null,
        date: null,
    })
    const visible = ref(false)
    const ride_type = ref('')
    const category = ref('')
    const table = ref({
        data:[],
        columns: [
            {
                title: t('rideDataStatistic.frame_number'),//'车架号'
                dataIndex: 'frame_number',
                key: 'frame_number',
                width: 160,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('rideDataStatistic.user_id'),//'用户ID'
                dataIndex: 'user_id',
                key: 'user_id',
                width: 100,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('rideDataStatistic.distance'),//'距离(米)'
                dataIndex: 'distance',
                key: 'distance',
                width: 130,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('rideDataStatistic.ride_no'),//'骑行编号/上电次数'
                dataIndex: 'ride_no',
                key: 'ride_no',
                width: 150,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('rideDataStatistic.cost_time'),//'骑行耗时(秒)'
                dataIndex: 'cost_time',
                key: 'cost_time',
                width: 120,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('rideDataStatistic.power_consumption'),//'耗电量'
                dataIndex: 'power_consumption',
                key: 'power_consumption',
                width: 170,
                ellipsis: true,
                resizable: true,
            },
            {
                title: t('rideDataStatistic.off_mode'),//'OFF档统计数'
                key: 'off_mode',
                dataIndex: 'off_mode',
                width: 120,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('rideDataStatistic.eco_mode'),//'ECO档统计数'
                key: 'eco_mode',
                dataIndex: 'eco_mode',
                width: 120,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('rideDataStatistic.tour_mode'),//'TOUR档统计数'
                key: 'tour_mode',
                dataIndex: 'tour_mode',
                width: 130,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('rideDataStatistic.turbo_mode'),//'TURBO档统计数'
                key: 'turbo_mode',
                dataIndex: 'turbo_mode',
                width: 140,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('rideDataStatistic.man_power'),//'人力统计数'
                key: 'man_power',
                dataIndex: 'man_power',
                width: 120,
                resizable: true,
                ellipsis: true,
            },
            {
                title: t('rideDataStatistic.motor_power'),//'助力统计数'
                key: 'motor_power',
                dataIndex: 'motor_power',
                width: 120,
                resizable: true,
                ellipsis: true,
            },
        ],
        configs:{
            table:{
                pagination:{
                    total:0,
                },
                rowClassName:(_record, index) => {return index % 2 === 1 ? 'table-striped' : null}
            },
            scroll:{
                x:1500,
                y:650,//设置表格高度，固定表头
            },  
            rowSelection:false,
            loading:false,
            pagination:{
                hideOnSinglePage:false,
                position:['bottomLeft'],
                responsive:true,// size 未指定时，根据屏幕宽度自动调整尺寸
                current:1,
                pageSize:10,
                pageSizeOptions:['10','20','50'],
                total:0,
                showTotal:()=>t('base.total') + ` ${table.value.configs.pagination.total} ` + t('base.row')
            },
            operateBtn:{
                showSearch:false,
                showAdd:false,
            }
        },
    })
    
    // 查询
    const handleSearch = ()=>{
        if(!vaild()) return
        dateTimestampeObj = useDateTimestamp(searchForm)
        table.value.configs.pagination.current = 1
        getList()
    }

    // 输入框
    const handleInputChange = debounce(()=>{
        console.log(searchForm, 'searchForm.frame_number,searchForm.date')
        if(!searchForm.frame_number && (searchForm.date == null || searchForm.date.length == 0)){
            table.value.configs.pagination.current = 1
            table.value.data = []
        }else{
            if(!searchForm.frame_number){
                message.error(t('rideDataStatistic.frameNumberMsg'))
                return
            }else if(searchForm.date == null || searchForm.date.length == 0){
                message.error(t('rideDataStatistic.dateMsg'))
                return
            }
            table.value.configs.pagination.current = 1
            getList()
        }
    }, 500)

    // 日期选择
    const handleDateChange = ()=>{
        if(!searchForm.frame_number && (searchForm.date == null || searchForm.date.length == 0)){
            table.value.configs.pagination.current = 1
            table.value.data = []
        }else{
            if(!searchForm.frame_number){
                message.error(t('rideDataStatistic.frameNumberMsg'))
                return
            }
            if(searchForm.date == null || searchForm.date.length == 0){
                message.error(t('rideDataStatistic.dateMsg'))
                return
            }
            dateTimestampeObj = useDateTimestamp(searchForm)
            table.value.configs.pagination.current = 1
            getList()
        }
    }

    // 分页
    const handleChangePagination = (config,data)=>{
        table.value.configs.pagination.current = config.current
        table.value.configs.pagination.pageSize = config.pageSize
        getList()
    }

    // 校验
    const vaild = ()=>{
        if(!searchForm.frame_number){
            message.error(t('rideDataStatistic.frameNumberMsg'))
            return false
        }else if(searchForm.date == null || searchForm.date.length == 0){
            message.error(t('rideDataStatistic.dateMsg')) 
            return false
        }
        return true
    }


    // 获取列表
    const getList = async ()=>{
        let param = {
            // email: queryForm.formData.email,
            // triple_id: queryForm.formData.triple_id,
            frame_number: searchForm.frame_number,
            start_timestamp: dateTimestampeObj.startDate.value,
            end_timestamp: dateTimestampeObj.endDate.value,
        }

        let { current, pageSize } = table.value.configs.pagination

        table.value.configs.loading = true
        let res = await RideDataStatistic.getInstance().getList(param, current, pageSize)
        if(res.code == 0){
            let data = res.data
            
            table.value.configs.pagination.total = data.total
            table.value.configs.pagination.current = data.current
            table.value.data = data.records

            table.value.configs.loading = false
        }else{
            message.error(res.msg);
        }
    }

    // 下载
    const handleDownLoad = (type)=>{
        if(!vaild()) return
        dateTimestampeObj = !!searchForm.date? useDateTimestamp(searchForm) : null
        
        if(type == 'ride'){
            visible.value = true
            category.value = ''
            ride_type.value = type
        }else{
            handleExport(type)
        }
    }

    // 确认下载骑行数据
    const handleOK = ()=>{
        handleExport(ride_type.value)
    }

    // 下载骑行数据/故障数据
    const handleExport = async (type)=>{
        let param = {
            // email: queryForm.formData.email,
            // triple_id: queryForm.formData.triple_id,
            frame_number: searchForm.frame_number,
            start_timestamp: dateTimestampeObj == null? '' : dateTimestampeObj.startDate.value,
            end_timestamp: dateTimestampeObj == null? '' : dateTimestampeObj.endDate.value,
        }

        category.value = category.value == undefined? '' : category.value
        spinning.value = true
        let res = type == 'ride'
            ? await RideDataStatistic.getInstance().downLoad(param, category.value)
            : await RideDataStatistic.getInstance().downLoadFaultData(param)

        if (!res.code) {
            let blob = new Blob([res.data])
            let a = document.createElement('a')
            a.href = URL.createObjectURL(blob)
            a.download = type == 'ride' ? t('rideDataStatistic.ride_points_data') + '.csv' : t('rideDataStatistic.fault_data') + '.csv'
            a.style.display = 'none'
            document.body.appendChild(a)
            a.click()
            URL.revokeObjectURL(a.href)
            document.body.removeChild(a)

            spinning.value = false
            visible.value = false
        } else {
            spinning.value = false
            Modal.error({
                title: t('base.tip'),
                content: res.msg,
            })
        }
    }

    onMounted(()=>{
       
    })
</script>

<style lang="scss" scoped>

.list{
    .table_setting{
        cursor: pointer;
    }

    ::v-deep .right_table_setting .anticon{
        font-size: 12px !important;
        margin: 5px 5px !important;
    }
    
    ::v-deep .ant-table {
        th,td {
            text-align: center;
        }
    }
}

::v-deep .ant-picker{
    width: 220px;
}



.query_box{
    margin: 40px 0 15px;
}

::v-deep .page_header .week{
    margin-top: -55px;
    transform: translateY(8px);
}

::v-deep .page_header .admin_email{
    margin-top: -55px;
    transform: translateY(18px);
}

::v-deep .ant-table-wrapper .ant-table-thead>tr>th, 
::v-deep .ant-table-wrapper .ant-table-tbody>tr>td, 
::v-deep .ant-table-wrapper tfoot>tr>td{
    padding: 6px 16px;
}

// 子表格的表体行样式
::v-deep .subTableBg{
    background: #f6f6f6 !important;
}

</style>